import closeSvg from '../../assets/svg/close.svg';

document.addEventListener('DOMContentLoaded', function () {
	const fwp = window.FWP;

	const facetsNode = document.querySelector('.facets');
	let facetsActiveNode = document.querySelector('.facets-active');

	if (!facetsActiveNode) {
		facetsActiveNode = document.createElement('div');
		facetsActiveNode.className = 'facets-active';
		facetsNode.insertAdjacentElement('afterend', facetsActiveNode);
	}

	if (!facetsNode) {
		return;
	}

	const resetLabel = function (node) {
		const { settings } = fwp;
		const name = node.dataset.name;

		if (!name) {
			return;
		}

		const label = settings.labels[ name ];

		if (!label) {
			return;
		}

		const labelNode = node.querySelector('.fs-label');

		if (!labelNode) {
			return;
		}

		labelNode.innerHTML = label;
	}

	document.addEventListener('facetwp-refresh', () => {
		facetsActiveNode.classList.add('facets-active--loading');
	});

	fwp.hooks.addAction('facetwp/loaded', (e) => {
		const { facets, facet_type, settings } = fwp;

		document.querySelectorAll('.facetwp-facet[data-type="fselect"]').forEach(resetLabel);

		// close the dropdowns after one has been selected
		facetsNode.querySelectorAll('.fs-open').forEach(node => node.classList.remove('fs-open'));
		facetsNode.querySelectorAll('.fs-dropdown').forEach(node => node.classList.add('hidden'));

		facetsActiveNode.classList.remove('facets-active--loading');
		facetsActiveNode.innerHTML = '';

		const fselects = Object.keys(facet_type).filter(facet => facet_type[ facet ] === 'fselect');


		const activeFacetCount = fselects.reduce((carry, facet) => carry + facets[ facet ].length, 0);

		if (activeFacetCount > 1) {
			const clearButton = document.createElement('button');
			clearButton.type = 'button';
			clearButton.className = 'facet-remove facet-remove--all';
			clearButton.insertAdjacentHTML('afterbegin', `Clear All ${closeSvg}`);
			clearButton.addEventListener('click', () => fwp.reset());

			facetsActiveNode.appendChild(clearButton);
		}

		const fSelect = facetsNode.querySelectorAll('.facetwp-type-fselect');
		//add labels above each facet
		if (fSelect.length) {
			fSelect.forEach(node => {
				const fLabel = node.querySelector('.facetwp-label');
				if (fLabel === null) {
					const facet_name = node.getAttribute('data-name');
					const facet_label = FWP.settings.labels[ facet_name ];
					let labelWrap = document.createElement("label");
					labelWrap.classList.add('facetwp-label');
					labelWrap.append(facet_label);
					node.prepend(labelWrap);
				}
			});
		}

		fselects.forEach(facet => {
			facets[ facet ].forEach(filter => {
				const removeButton = document.createElement('button');
				const option = document.querySelector(`.facetwp-facet[data-name="${facet}"] .fs-option[data-value="${filter}"] .fs-option-label`);
				const label = option ? option.innerText.trim().replace(/\(\d+\)$/, '') : filter;

				removeButton.type = 'button';
				removeButton.className = 'facet-remove facet-remove--one';
				removeButton.insertAdjacentHTML('afterbegin', `${label} ${closeSvg}`);
				removeButton.addEventListener('click', () => {
					facetsActiveNode.classList.add('facets-active--loading');

					window.FWP.facets[ facet ] = facets[ facet ].filter(f => f !== filter);
					window.FWP.fetchData();
					window.FWP.setHash();

					if (window.FWP.last_active_facet) {
						delete window.FWP.last_active_facet;
					}
				});

				facetsActiveNode.appendChild(removeButton);
			});
		});

		// scroll the body back up to the facets if we're below (e.g. pagination)
		if (facetsNode && facetsNode.getBoundingClientRect().top < 0 && window.wdg.scripts.header.headroom) {
			// unpin and freeze the header so we don't cover up the facets when we scroll back up
			const { headroom } = window.wdg.scripts.header;
			headroom.freeze();
			headroom.unpin();

			facetsNode.scrollIntoView({ behavior: 'smooth' });

			// there's no callback for scrollIntoView - the just wait an arbirtary time to unfreeze the header
			setTimeout(() => headroom.unfreeze(), 1000);
		}

	});
});